var viewer_caption_default = {
  "fontElementMap": "UPQNO",
  "imageCaption": "hLCnb"
};
export {
  viewer_caption_default as default
};
//# sourceMappingURL=viewer-caption-scss.js.map
